export const networking = {
  'QrBadge': 'QR 배지',
  'seeAll': '모두 보기',
  'newcommers': 'New Networkers',
  'checkThemOut': '확인해보세요!',
  'topicsToDiscuss': '토론할 주제',
  'OneOnOneMeet': '1:1 미팅',
  'message': '메시지',
  'learnMoreNetworking': 'Networking Hub에 대해 더 알아보기',
  'scanQrCode': 'QR 코드 스캔',
  'myBadge': '내 배지',
  'scannedBadge': '스캔된 배지',
  'viewProfile': '프로필 보기',
  'userRatingDetails': '사용자 평가 세부사항',
  'networkingHub': 'Networking Hub',
  'totalScore': '총 점수:',
  'scoreComposedOf': '이 점수는 다음으로 구성됩니다:',
  'confirmationText': '정확합니까? 이것은 되돌릴 수 없습니다.',

  'welcomeMessage': '<strong>Networking Hub</strong>에 오신 것을 환영합니다! 여기서 어떻게 작동하는지 확인하세요:',
  'connectingMadeSimpleTitle': '간단한 연결',
  'connectingMadeSimpleDescription': 'Networking Hub은 효과적으로 연결할 수 있도록 구조화된 활동과 레벨을 제공합니다:',

  'newcomersDescription':
    '<strong>Newcomers:</strong> 신규 회원의 프로필을 탐색하고, 관심 있는 사람을 선택 목록에 추가하고 메시지를 보낼 수 있습니다. 개인적으로 연결할 수도 있습니다.',
  'shortlistDescription': '<strong>Shortlist:</strong> 누군가에게 관심을 보이면 해당 사용자가 선택 목록에 추가됩니다.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> 누군가에게 연락을 하고 응답을 받으면 이 카테고리로 이동합니다.',
  'skipDescription': '<strong>Skip:</strong> 관심이 없으면 프로필을 건너뛰고 계속 진행하세요!',

  'enhancedNetworkingActivitiesTitle': '향상된 네트워킹 활동',
  'enhancedNetworkingActivitiesDescription': '직접적인 연결 외에도 Hub에는 다음과 같은 항목이 포함됩니다:',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> 관심 있는 주제를 탐색하고 저자나 참가자와 연결하세요. 온라인 토론에 참여하거나 그룹 미팅을 예약하여 주제를 더 깊이 논의할 수 있습니다.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> 미팅 요청을 관리하고 예정된 미팅을 추적하며 일정을 쉽게 조정하세요.',

  'gamificationTitle': '재미와 참여를 위한 게임화',
  'gamificationDescription':
    '리더보드에서 활동을 추적하고 가장 활발한 네트워커를 확인할 수 있습니다. 다음과 같은 방법으로 포인트를 획득할 수 있습니다:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1,000 포인트:</strong> 프로필을 완료하세요 (사진 포함).',
    points1000PushNotifications: '<strong>1,000 포인트:</strong> 푸시 알림을 활성화하세요.',
    points100SendMeetingRequest: '<strong>100 포인트:</strong> 1:1 미팅 요청을 보내세요.',
    points400GetAcceptedRequest: '<strong>400 포인트:</strong> 1:1 미팅 요청을 승인받으세요.',
    points400AcceptRequest: '<strong>400 포인트:</strong> 1:1 미팅 요청을 수락하세요.',
    points100DeclineRequest: '<strong>100 포인트:</strong> 1:1 미팅 요청을 거절하세요.',
    points400CreateDiscussion: '<strong>400 포인트:</strong> 토론 주제를 생성하세요.',
    points50LikeDiscussion: '<strong>50 포인트:</strong> 토론 주제에 좋아요를 눌러주세요.',
    points200PostFirstComment: '<strong>200 포인트:</strong> 다른 주제에 첫 댓글을 달 때마다.',
    points100LikeOnTopic: '<strong>100 포인트:</strong> 주제에 좋아요를 받으세요.',
    points200UniqueCommenter: '<strong>200 포인트:</strong> 주제에 고유한 댓글을 작성하세요.',
    points100LikeShortlistUser: '<strong>100 포인트:</strong> 사용자에게 좋아요를 누르거나 선택 목록에 추가하세요.',
    points50SkipUser: '<strong>50 포인트:</strong> 사용자를 건너뛰세요.',
    points200StartChat: '<strong>200 포인트:</strong> 채팅 시작하기 (연락됨).',
    points300GetChatResponse: '<strong>300 포인트:</strong> 채팅에서 응답을 받기 (연결됨).',
    points400RespondToChat: '<strong>400 포인트:</strong> 채팅 요청에 응답하기 (연결됨).',
    points500SpeedNetworking: '<strong>500포인트:</strong> 각 스피드 네트워킹 세션마다.'
  },

  'finalMessage': 'Networking Hub를 최대한 활용하여 새로운 기회를 발견하고, 네트워크를 확장하며 리더보드에서 순위를 올리세요!',

  'manageMeeting': '회의 관리',
  'addToCalendar': '캘린더에 추가',
  'cancel': '취소',
  'accept': '수락',
  'accept&addToCalendar': '수락하고 캘린더에 추가',
  'editDetails': '세부 정보 수정',
  'reject': '거절',
  'delete': '삭제',
  'exportContact': '연락처 내보내기',
  'scheduleNewOneOnOne': '새로운 1:1 일정 잡기',
  'initiatedBy': '시작한 사람',
  'rejectedBy': '거절한 사람',
  'you': '당신',
  'meetPassed': '회의가 종료되었습니다',
  'meetInProgress': '진행 중',

  'myOneOnOne': '내 1:1',

  'speed': {
    history: '기록',
    minutes: '분',
    users_available: '사용자 이용 가능',
    rules: '규칙',
    activate: '활성화',
    matching: '매칭 중...',
    start: '시작',
    find_a_user: '같은 이미지를 가진 사용자 찾기',
    find_a_user_number: '같은 번호를 가진 사용자를 찾기',
    waiting: '대기 중...',
    speaking_now: '현재 말하는 중',
    networking_topics: '네트워킹 주제',
    session_ended: '세션 종료',
    find_next_partner: '다음 파트너 찾기',
    find_next_group: '다음 그룹 찾기',
    partner_wasnt_ready: '파트너가 준비되지 않았습니다',
    partner_wasnt_ready_description: '파트너가 토론할 준비가 되지 않은 것 같습니다. 새로운 파트너를 찾아봅시다!',
    start_matching: '매칭 시작'
  }
}
